document.addEventListener('DOMContentLoaded', () => {
  const form = document.getElementById('mm-cart-form');
  if (!form) return;

  const updateBtn = form.querySelector('button[name="update"]');
  const submitWithUpdate = () => {
    if (updateBtn && updateBtn.type === 'submit') updateBtn.click();
    else form.requestSubmit();
  };

  let t;
  form.querySelectorAll('.mm-cart__qty-input').forEach(input => {
    input.addEventListener('input', () => {
      clearTimeout(t);
      t = setTimeout(submitWithUpdate, 1900);
    });
    input.addEventListener('change', submitWithUpdate);
  });
});
